

































import { Component, Prop, Vue } from 'vue-property-decorator';

export declare interface SelectorItem {
  value: string | number;
  title: string;
}

@Component({})
export default class UiKitSelect extends Vue {
  @Prop() public value: any;
  @Prop() public items: SelectorItem[];
  @Prop() public placeholder!: string;
  @Prop() public title?: string;
  @Prop() public name!: string;
  @Prop({ default: () => ({ $error: false }) }) public errors?: object;
  @Prop({ default: () => ({}) }) public errorMessages?: object;
}
